"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var react_i18next_1 = require("react-i18next");
var notification_1 = __importDefault(require("../../helpers/notification"));
var logger_1 = __importDefault(require("../../helpers/logger"));
var FormatText_1 = __importDefault(require("../FormatText"));
var __1 = require("../..");
var Dragger = antd_1.Upload.Dragger;
var handleOnChange = function (info, t) {
    var status = info.file.status;
    if (status !== 'uploading') {
        logger_1.default.log(info.file, info.fileList);
    }
    if (status === 'done') {
        notification_1.default.success(t('ui.message.upload.success', { filename: info.file.name }));
    }
    else if (status === 'error') {
        notification_1.default.error(t('ui.message.upload.fail', { filename: info.file.name }));
    }
};
var Upload = function (props) {
    var t = react_i18next_1.useTranslation().t;
    var type = props.type;
    var receiveProps = __assign({ onChange: function (info) { return handleOnChange(info, t); } }, props);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        type === 'drag' && (react_1.default.createElement(Dragger, __assign({}, receiveProps),
            react_1.default.createElement("p", { className: "ant-upload-drag-icon" },
                react_1.default.createElement(antd_1.Icon, { type: "inbox" })),
            react_1.default.createElement("p", { className: "ant-upload-text" },
                react_1.default.createElement(FormatText_1.default, { id: "ui.message.upload.clickArea" })))),
        type === 'select' && (react_1.default.createElement(antd_1.Upload, __assign({}, receiveProps),
            react_1.default.createElement(__1.Button, null,
                react_1.default.createElement(antd_1.Icon, { type: "upload" }),
                react_1.default.createElement(FormatText_1.default, { id: "ui.message.upload.select" }))))));
};
exports.default = Upload;
